import { render, staticRenderFns } from "./ArqCrud.vue?vue&type=template&id=2361ca1f&"
import script from "./ArqCrud.vue?vue&type=script&lang=js&"
export * from "./ArqCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports